import "./search-stats.scss";

import cn from "clsx";
import { Icon } from "design-system/components/icons/icon";
import { DateRange } from "react-day-picker";
import { format } from "date-fns";

export interface SearchStatsProps {
  teaseType?: string;
  totalHits?: number;
  searchQuery?: string;
  facetValues?: Array<string>;
  dateRange?: DateRange;
  onClearAll?: () => void;
}

export function SearchStats({
  teaseType,
  totalHits,
  searchQuery,
  facetValues = [],
  dateRange,
  onClearAll,
}: SearchStatsProps) {
  const dateFrom = dateRange?.from && format(dateRange.from, "M/d/y");
  const dateTo = dateRange?.to && format(dateRange.to, "M/d/y");

  return (
    <div className="hbs-search-stats">
      <p className="hbs-search-stats__summary" role="status">
        Showing <strong>{totalHits?.toLocaleString("en-US")}</strong>{" "}
        {teaseType || "result"}
        {totalHits === 1 ? "" : "s"}
        {!!searchQuery && (
          <>
            {" "}
            for <strong>{searchQuery}</strong>
            {facetValues.length > 0 && ", "}
          </>
        )}
        {facetValues.length > 0 && (
          <>
            {" "}
            under{" "}
            {facetValues.map((facetValue, i) => (
              <span key={i}>
                <strong>{facetValue}</strong>
                {i !== facetValues.length - 1 && (
                  <>
                    {facetValues.length !== 2 ? "," : ""}{" "}
                    {facetValues.length > 1 &&
                      i === facetValues.length - 2 &&
                      "and"}{" "}
                  </>
                )}
              </span>
            ))}
          </>
        )}
        {dateFrom && dateTo && (
          <>
            {" between "}
            <strong>{dateFrom}</strong>
            {" and "}
            <strong>{dateTo}</strong>
          </>
        )}
        {dateFrom && !dateTo && (
          <>
            {" with dates from "}
            <strong>{dateFrom}</strong>
          </>
        )}
        {!dateFrom && dateTo && (
          <>
            {" with dates to "}
            <strong>{dateTo}</strong>
          </>
        )}
      </p>

      <button
        className={cn(
          "hbs-search-stats__clear",
          onClearAll &&
            (searchQuery || facetValues.length > 0 || dateFrom || dateTo) &&
            "hbs-search-stats__clear--visible",
        )}
        onClick={onClearAll}
      >
        Clear all <Icon className="hbs-search-stats__clear-icon" name="close" />
      </button>
    </div>
  );
}
